module.exports = __webpack_public_path__ + "img/first-layer-3.6340cd6c.png";